/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Evidence_Card_LabelInputs */

const en_directory_detail_evidence_card_label = /** @type {(inputs: Directory_Detail_Evidence_Card_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification ledger`)
};

const zh_directory_detail_evidence_card_label = /** @type {(inputs: Directory_Detail_Evidence_Card_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核验台账`)
};

/**
* | output |
* | --- |
* | "Verification ledger" |
*
* @param {Directory_Detail_Evidence_Card_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_evidence_card_label = /** @type {((inputs?: Directory_Detail_Evidence_Card_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Evidence_Card_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_evidence_card_label(inputs)
	return zh_directory_detail_evidence_card_label(inputs)
});
export { directory_detail_evidence_card_label as "directory.detail.evidence_card_label" }